import {
  SiVuedotjs, SiReact, SiAngular, SiJavascript, SiTypescript, SiNuxtdotjs,
  SiNextdotjs, SiBootstrap, SiTailwindcss, SiFigma, SiAdobexd, SiSketch,
  SiNodeDotJs, SiExpress, SiMongodb, SiMysql, SiPostgresql, SiFirebase,
  SiAndroid, SiApple, SiFlutter, SiDart, SiMagento, SiShopify, SiWoocommerce,
  SiWordpress, SiJenkins, SiDocker, SiKubernetes, SiAmazonaws, SiGooglecloud,
  SiMicrosoftazure, SiGraphql, SiMongoose,
  SiSwift,
  SiKotlin,
  SiSpringboot,
  SiDotnet,
  SiPython,
  SiGo,
  SiNodedotjs,
  SiAmazonwebservices,
  SiTensorflow,
  SiPytorch,
  SiScikitlearn,
  SiKeras,
  SiOpencv,
  SiHuggingface,
  SiLangchain,
  SiOpenai,
  SiGithubactions,
  SiAmazondynamodb,
  SiApachekafka,
  SiRabbitmq,
  SiMqtt,
  SiSelenium,
  SiCypress,
  SiJest,
  SiApachejmeter
} from 'react-icons/si';

export const categories = ['Backend', 'Frontend', 'Mobile', 'UI/UX','AI & ML', 'Cloud & DevOps', 'Database', 'QA & Testing',];

export const techStacks = {
  'UI/UX': [
    { name: 'Figma', icon: <SiFigma className="text-pink-400" /> },
    { name: 'Adobe XD', icon: <SiAdobexd className="text-purple-400" /> },
    { name: 'Sketch', icon: <SiSketch className="text-yellow-300" /> },
  ],
  'Frontend': [
    { name: 'Vue.js', icon: <SiVuedotjs className="text-green-400" /> },
    { name: 'React', icon: <SiReact className="text-blue-400" /> },
    { name: 'Angular', icon: <SiAngular className="text-red-500" /> },
    { name: 'JavaScript', icon: <SiJavascript className="text-yellow-300" /> },
    { name: 'TypeScript', icon: <SiTypescript className="text-blue-500" /> },
    { name: 'Nuxt.js', icon: <SiNuxtdotjs className="text-green-300" /> },
    { name: 'Next.js', icon: <SiNextdotjs className="text-gray-300" /> },
    { name: 'Bootstrap', icon: <SiBootstrap className="text-purple-500" /> },
    { name: 'Tailwind', icon: <SiTailwindcss className="text-teal-400" /> },
  ],
  'Backend': [
    // { name: 'Java', icon: <SiJava className="text-gray-300" /> },
    { name: 'Spring Boot', icon: <SiSpringboot className="text-gray-300" /> },
    { name: '.Net', icon: <SiDotnet className="text-pink-500" /> },
    { name: 'Python', icon: <SiPython className="text-red-400" /> },
    { name: 'Next.js', icon: <SiNextdotjs className="text-gray-300" /> },
    { name: 'Node.js', icon: <SiNodedotjs className="text-green-400" /> },
    { name: 'Express.js', icon: <SiExpress className="text-gray-300" /> },
    { name: 'Graph QL', icon: <SiGraphql className="text-red-400" /> },
    { name: 'Go', icon: <SiGo className="text-red-400" /> },
    // { name: 'Keycloak', icon: <SiKeycloak className="text-red-400" /> },
  ],
  'Mobile': [
    { name: 'Swift', icon: <SiSwift className="text-green-500" /> },
    { name: 'Kotlin', icon: <SiKotlin className="text-gray-100" /> },
    { name: 'React Native', icon: <SiReact className="text-gray-100" /> },
    { name: 'Flutter', icon: <SiFlutter className="text-blue-400" /> },
  ],
  'QA & Testing': [
    { name: 'Selenium', icon: <SiSelenium className="text-orange-500" /> },
    { name: 'Cypress', icon: <SiCypress className="text-green-500" /> },
    { name: 'Jest', icon: <SiJest className="text-purple-400" /> },
    { name: 'Jmeter', icon: <SiApachejmeter className="text-purple-400" /> },
  ],
  'AI & ML': [
    { name: 'TensorFlow', icon: <SiTensorflow className="text-blue-500" /> },
    { name: 'PyTorch', icon: <SiPytorch className="text-orange-500" /> },
    { name: 'Scikit-learn', icon: <SiScikitlearn className="text-green-500" /> },
    { name: 'Keras', icon: <SiKeras className="text-red-500" /> },
    { name: 'OpenCV', icon: <SiOpencv className="text-blue-400" /> },
    { name: 'Hugging Face', icon: <SiHuggingface className="text-orange-400" /> },
    { name: 'LangChain', icon: <SiLangchain className="text-green-400" /> },
    { name: 'OpenAI', icon: <SiOpenai className="text-gray-300" /> },

  ],
  'Cloud & DevOps': [
    { name: 'AWS', icon: <SiAmazonwebservices className="text-orange-400" /> },
    // { name: 'Azure', icon: <Si className="text-blue-600" /> },
    { name: 'Google Cloud', icon: <SiGooglecloud className="text-blue-300" /> },
    { name: 'GitHub Actions', icon: <SiGithubactions className="text-gray-300" /> },
    { name: 'Jenkins', icon: <SiJenkins className="text-red-500" /> },
    { name: 'Docker', icon: <SiDocker className="text-blue-400" /> },
    { name: 'Kubernetes', icon: <SiKubernetes className="text-blue-500" /> },
    { name: 'Apache Kafka', icon: <SiApachekafka className="text-blue-600" /> },
    { name: 'RabbitMQ', icon: <SiRabbitmq className="text-blue-600" /> },
    { name: 'MQTT', icon: <SiMqtt className="text-blue-600" /> },
  ],
  'Database': [
    { name: 'MongoDB', icon: <SiMongodb className="text-green-500" /> },
    { name: 'MySQL', icon: <SiMysql className="text-blue-400" /> },
    { name: 'PostgreSQL', icon: <SiPostgresql className="text-blue-500" /> },
    { name: 'DynamoDB', icon: <SiAmazondynamodb className="text-yellow-400" /> },
  ],
};
